import React from 'react';
import OrganizationMembershipManager from '../Profile/OrganizationMembershipManager';
import SheetsHeader from './SheetsHeader';

const OrganizationsPage = () => (
  <div className="mx-auto w-full max-w-5xl space-y-5">
    <SheetsHeader
      activeTab="organizations"
      badge="Organisations"
      backPath="/sheets"
      backAriaLabel="Back to sheets"
      title="Organisation Access"
      description="Manage memberships, approvals, and the organisation context used by sheets and workspaces."
    />
    <OrganizationMembershipManager />
  </div>
);

export default OrganizationsPage;
